import { createContext, useContext, useState } from "react";

// Criação do contexto
export const UserContext = createContext();

// Função de provedor de contexto
export default function UserProvider({ children }) {
    const [userCode, setUserCode] = useState(null);
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [userFunctionalities, setUserFunctionalities] = useState([]);
    const [userPerfils, setUserPerfils] = useState([]);
    const [userAtivo, setUserAtivo] = useState(false);
    const [userGestor, setUserGestor] = useState(null)
    const [userId, setUserId] = useState(null);

    // Adição das variáveis enums
    const [motivoEncerramentoEnum, setMotivoEncerramentoEnum] = useState([]);
    const [processoPessoaTipo, setProcessoPessoaTipo] = useState([]);
    const [processoStatus, setProcessoStatus] = useState([]);
    const [profileType, setProfileType] = useState([]);
    const [relacaoJuridico, setRelacaoJuridico] = useState([]);
    const [roboEditalStatus, setRoboEditalStatus] = useState([]);
    const [roboEditalWibsStatus, setRoboEditalWibsStatus] = useState([]);
    const [statusCasoProcessual, setStatusCasoProcessual] = useState([]);
    const [tipoCasoEnum, setTipoCasoEnum] = useState([]);
    const [sistemasEnum, setSistemasEnum] = useState([]);
    const [tipoComplementoJusticaEnum, setTipoComplementoJusticaEnum] = useState([]);
    const [tipoIndiceEnum, setTipoIndiceEnum] = useState([]);
    const [tipoJusticaEnum, setTipoJusticaEnum] = useState([]);
    const [tipoPessoaEnum, setTipoPessoaEnum] = useState([]);
    const [tipoPartesEnum, setTipoPartesEnum] = useState([]);
    const [fonteMovimentacaoEnum, setFonteMovimentacaoEnum] = useState([]);
    const [statusProcesso, setStatusProcesso] = useState([]);
    const [tipoMovimentacaoEnum, setTipoMovimentacaoEnum] = useState([]);
    const [statusPrazoEnum, setStatusPrazoEnum] = useState([]);
    const [tipoEventoEnum, setTipoEventoEnum] = useState([]);
    const [tipoPerfilEnum, setTipoPerfilEnum] = useState([]);
    const [tipoFiltroAgendaEnum, setTipoFiltroAgendaEnum] = useState([]);
    const [tipoAgendaEnum, setTipoAgendaEnum] = useState([]);
    const [tipoSistemaEnum, setTipoSistemaEnum] = useState([]);
    const [tipoDocumentoProcessoEnum, setTipoDocumentoProcessoEnum] = useState([]);

    return (
        <UserContext.Provider value={{
            userCode, setUserCode,
            userName, setUserName,
            userEmail, setUserEmail,
            userFunctionalities, setUserFunctionalities,
            userPerfils, setUserPerfils,
            userAtivo, setUserAtivo,
            userGestor, setUserGestor,
            userId, setUserId,
            motivoEncerramentoEnum, setMotivoEncerramentoEnum,
            processoPessoaTipo, setProcessoPessoaTipo,
            processoStatus, setProcessoStatus,
            profileType, setProfileType,
            relacaoJuridico, setRelacaoJuridico,
            roboEditalStatus, setRoboEditalStatus,
            roboEditalWibsStatus, setRoboEditalWibsStatus,
            statusCasoProcessual, setStatusCasoProcessual,
            tipoCasoEnum, setTipoCasoEnum,
            tipoComplementoJusticaEnum, setTipoComplementoJusticaEnum,
            tipoIndiceEnum, setTipoIndiceEnum,
            tipoJusticaEnum, setTipoJusticaEnum,
            tipoPessoaEnum, setTipoPessoaEnum,
            tipoPartesEnum, setTipoPartesEnum,
            fonteMovimentacaoEnum, setFonteMovimentacaoEnum,
            tipoMovimentacaoEnum, setTipoMovimentacaoEnum,
            statusProcesso, setStatusProcesso,
            sistemasEnum, setSistemasEnum,
            statusPrazoEnum, setStatusPrazoEnum,
            tipoEventoEnum, setTipoEventoEnum: setTipoEventoEnum,
            tipoPerfilEnum, setTipoPerfilEnum,
            tipoFiltroAgendaEnum, setTipoFiltroAgendaEnum,
            tipoAgendaEnum, setTipoAgendaEnum,
            tipoSistemaEnum, setTipoSistemaEnum,
            tipoDocumentoProcessoEnum, setTipoDocumentoProcessoEnum
        }}>
            {children}
        </UserContext.Provider>
    );
}

// Hook personalizado para usar o contexto
export function useUser() {
    const context = useContext(UserContext);

    if (!context) {
        throw new Error("useUser must be used within a UserProvider");
    }

    const {
        userCode, setUserCode,
        userName, setUserName,
        userEmail, setUserEmail,
        userFunctionalities, setUserFunctionalities,
        userPerfils, setUserPerfils,
        userAtivo, setUserAtivo,
        userGestor, setUserGestor,
        userId, setUserId,
        motivoEncerramentoEnum, setMotivoEncerramentoEnum,
        processoPessoaTipo, setProcessoPessoaTipo,
        processoStatus, setProcessoStatus,
        profileType, setProfileType,
        relacaoJuridico, setRelacaoJuridico,
        roboEditalStatus, setRoboEditalStatus,
        roboEditalWibsStatus, setRoboEditalWibsStatus,
        statusCasoProcessual, setStatusCasoProcessual,
        tipoCasoEnum, setTipoCasoEnum,
        tipoComplementoJusticaEnum, setTipoComplementoJusticaEnum,
        tipoIndiceEnum, setTipoIndiceEnum,
        tipoJusticaEnum, setTipoJusticaEnum,
        tipoPessoaEnum, setTipoPessoaEnum,
        tipoPartesEnum, setTipoPartesEnum,
        fonteMovimentacaoEnum, setFonteMovimentacaoEnum,
        tipoMovimentacaoEnum, setTipoMovimentacaoEnum,
        statusProcesso, setStatusProcesso,
        statusPrazoEnum, setStatusPrazoEnum,
        sistemasEnum, setSistemasEnum,
        tipoEventoEnum, setTipoEventoEnum,
        tipoPerfilEnum, setTipoPerfilEnum,
        tipoFiltroAgendaEnum, setTipoFiltroAgendaEnum,
        tipoAgendaEnum, setTipoAgendaEnum,
        tipoSistemaEnum, setTipoSistemaEnum,
        tipoDocumentoProcessoEnum, setTipoDocumentoProcessoEnum
    } = context;

    return {
        userCode, setUserCode,
        userName, setUserName,
        userEmail, setUserEmail,
        userFunctionalities, setUserFunctionalities,
        userPerfils, setUserPerfils,
        userAtivo, setUserAtivo,
        userGestor, setUserGestor,
        userId, setUserId,
        motivoEncerramentoEnum, setMotivoEncerramentoEnum,
        processoPessoaTipo, setProcessoPessoaTipo,
        processoStatus, setProcessoStatus,
        profileType, setProfileType,
        relacaoJuridico, setRelacaoJuridico,
        roboEditalStatus, setRoboEditalStatus,
        roboEditalWibsStatus, setRoboEditalWibsStatus,
        statusCasoProcessual, setStatusCasoProcessual,
        tipoCasoEnum, setTipoCasoEnum,
        tipoComplementoJusticaEnum, setTipoComplementoJusticaEnum,
        tipoIndiceEnum, setTipoIndiceEnum,
        tipoJusticaEnum, setTipoJusticaEnum,
        tipoPessoaEnum, setTipoPessoaEnum,
        tipoPartesEnum, setTipoPartesEnum,
        fonteMovimentacaoEnum, setFonteMovimentacaoEnum,
        tipoMovimentacaoEnum, setTipoMovimentacaoEnum,
        statusProcesso, setStatusProcesso,
        statusPrazoEnum, setStatusPrazoEnum,
        sistemasEnum, setSistemasEnum,
        tipoEventoEnum, setTipoEventoEnum,
        tipoPerfilEnum, setTipoPerfilEnum,
        tipoFiltroAgendaEnum, setTipoFiltroAgendaEnum,
        tipoAgendaEnum, setTipoAgendaEnum,
        tipoSistemaEnum, setTipoSistemaEnum,
        tipoDocumentoProcessoEnum, setTipoDocumentoProcessoEnum
    };
}
